import React, { useEffect, useState } from 'react';

import { Button } from '@ast/magma';

import { FlexContainer } from '@app/common/components/FlexContainer/FlexContainer';
import { OverlaySpinner } from '@app/common/components/overlayspinner';

import { useUserSettingsTranslation } from '@app/widgets/contacts-and-settings/hooks/useUserSettingsTranslation';

import { ErrorDialog } from './components/ErrorDialog';
import { PasskeyList } from './components/PasskeyList';
import { PasskeyModal } from './components/PasskeyModal';
import { SuccessDialog } from './components/SuccessDialog';

import { usePasskeyRegister } from './usePasskeyRegister';
import { usePasskeyRevoke } from './usePasskeyRevoke';

export const RegisterPasskeyField: React.FC = () => {
  const { t } = useUserSettingsTranslation();
  const [isModalVisible, setModalVisibility] = useState(false);

  const [isSuccessDialogVisible, setSuccessDialogVisibility] = useState(false);
  const [isErrorDialogVisible, setErrorDialogVisibility] = useState(false);

  const {
    registeredPasskeys, isLoading, getRegisteredPasskeys, handleStartRegistration,
  } = usePasskeyRegister({ setErrorDialogVisibility, setSuccessDialogVisibility });

  const {
    isLoading: isLoadingRevokePasskey,
    passkeyRevokeError,
    revokePasskey,
  } = usePasskeyRevoke({ getRegisteredPasskeys });

  useEffect(() => {
    getRegisteredPasskeys();
  }, []);

  return (
    <FlexContainer
      direction="column"
    >
      <>
        <p className="md">
          {t('profile-and-security.register-passkey-info-message-paragraph-1|Info message for register passkey. Paragraph 1',
            'When you try to log in, we\'ll send a push notification to the smartphone you used when you registered the account. When you use your face, fingerprint, or PIN code to unlock the device, a unique passkey will be created and sent to our website. At this point, you will be logged in, all without your login information or biometric data needing to be typed out or transmitted.')}
        </p>
        <div>
          <span className="md">
            {t('profile-and-security.register-passkey-info-message-paragraph-2|Info message for register passkey. Paragraph 2',
              'Passkeys can sync across devices. They’re seamless and convenient to use.')}
          </span>
          {' '}
          <Button look="inlinetext" onClick={() => setModalVisibility(true)}>
            {t('profile-and-security.register-passkey-info-message-link-text|Info message for register passkey link text',
              'Learn more about passkey')}
          </Button>

        </div>
      </>

      {isLoading && (
      <OverlaySpinner
        visible
      />
      )}
      {isSuccessDialogVisible && <SuccessDialog onClose={() => setSuccessDialogVisibility(false)} />}
      {isErrorDialogVisible && <ErrorDialog onClose={() => setErrorDialogVisibility(false)} />}
      <PasskeyModal isVisible={isModalVisible} setVisible={setModalVisibility} />
      <PasskeyList
        isLoadingRevokePasskey={isLoadingRevokePasskey}
        passkeyRevokeError={passkeyRevokeError}
        registeredPasskeys={registeredPasskeys}
        handleStartRegistration={handleStartRegistration}
        onDeletePasskey={revokePasskey}
      />
    </FlexContainer>
  );
};
